import React, { useRef, useState, useEffect } from "react";

const WebcamCapture = ({ onCapture, captureInterval = 1000 }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [isCapturing, setIsCapturing] = useState(false);
  const captureIntervalRef = useRef(null);

  const startCamera = async () => {
    setIsCapturing(true);
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    videoRef.current.srcObject = stream;

    captureIntervalRef.current = setInterval(() => {
      captureImage();
    }, captureInterval);
  };

  const stopCamera = () => {
    setIsCapturing(false);
    clearInterval(captureIntervalRef.current);
    if (videoRef.current && videoRef.current.srcObject) {
      videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
    }
  };

  const captureImage = () => {
    if (!videoRef.current || !canvasRef.current) return;

    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

    const imageBase64 = canvas.toDataURL("image/png");

    onCapture(imageBase64);
  };

  return (
    <div>
      {!isCapturing ? (
        <button onClick={startCamera}>▶️ Play</button>
      ) : (
        <>
          <video
            ref={videoRef}
            style={{ display: "none" }}
            autoPlay
            width="200"
            height="150"
          ></video>
          <canvas
            ref={canvasRef}
            width="100"
            height="100"
            style={{ display: "none" }}
          ></canvas>
          <button onClick={stopCamera}>⏹ Stop</button>
        </>
      )}
    </div>
  );
};

export default WebcamCapture;
